/** Domain portal admin: `/` render AdminPage (xem App.js). */
export function isAdminPortalHostname(hostname) {
    if (!hostname) return false;
    const h = String(hostname).toLowerCase();
    return h === 'admin.ikara.co' || h === 'admin.yokara.com';
}

/**
 * URL "Quay về trang chủ" theo domain hiện tại (404, 500, v.v.).
 */
export function getBackHomeUrl() {
    if (typeof window === 'undefined') {
        return 'https://www.ikara.co/';
    }
    const host = window.location.hostname.toLowerCase();
    if (host === 'admin.ikara.co') {
        return 'https://admin.ikara.co/';
    }
    if (host === 'www.ikara.co' || host === 'ikara.co') {
        return 'https://www.ikara.co/';
    }
    if (host === 'admin.yokara.com') {
        return 'https://admin.yokara.com/';
    }
    if (host === 'www.yokara.com' || host === 'yokara.com') {
        return 'https://www.yokara.com/';
    }
    if (host === 'dev.ikara.co') {
        return 'https://dev.ikara.co/';
    }
    return 'https://www.ikara.co/';
}
